export const projects = [
  {
    id: 4, 
    title: 'Personal Portfolio Website',
    description: 'The responsive portfolio website you are currently viewing. Built with React and styled-components to showcase my projects and skills.',
    image: '/screenshot.png',
    tags: ['React', 'Styled-Components', 'React Router', 'UI/UX'],
    liveUrl: 'https://naledi-portfolio.vercel.app/', 
    repoUrl: 'https://github.com/Naledi-starr/Naledi-Portfolio', 
  },
  {
    id: 1,
    title: 'Advice Generator',
    description: 'Built a dynamic, responsive web app using HTML, CSS, and JavaScript, integrating the Advice Slip API to deliver real-time advice quotes. Designed a mobile-first UI with accessibility features and smooth animations.',
    image: '/2.png',
    tags: ['REST API', 'CSS', 'HTML', 'JavaScript', 'Vercel'],
    liveUrl: 'https://advisor-generator-p5c7.vercel.app/',
    repoUrl: 'https://github.com/Naledi-starr/advisor-generator',
  },
  {
    id: 2,
    title: 'Lifestyle Surveys',
    description: 'Built a stylish web app to collect and display food and lifestyle preferences. Designed a Burberry-inspired UI and ensured a smooth user experience. Implemented form validation and dynamic survey result features.',
    image: '/3.png',
    tags: ['Python Flask', 'Bootstrap', 'HTML', 'JavaScript', 'SQLite'],
    liveUrl: '#',
    repoUrl: 'https://github.com/Naledi-starr/Food-Survey?tab=readme-ov-file',
  },
  {
    id: 3,
    title: 'Vhaswa Vuhani Prototype',
    description: 'Produced a clear and effective plan for the team, improved UI design skills designed and presented a well-structured presentation.',
    image: '/4.png',
    tags: ['Planning', 'UI Design', 'Presentation'],
    liveUrl: 'https://www.canva.com/design/DAGdO90KaZ4/a8X2_RjPZZ92rM22PKD_dg/view?utm_content=DAGdO90KaZ4&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h1d4fd2db19',
    repoUrl: '#',
  },
  {
    id: 5,
    title: 'Time Bestie - Time Manager App',
    description: 'A modern, feature-rich personal time tracking application with a beautiful dark-themed UI. Track daily and weekly tasks, manage priorities, and monitor productivity with real-time timers. Built with vanilla JavaScript, HTML5, CSS3, and Tailwind CSS.',
    image: '/8.png',
    tags: ['JavaScript', 'Tailwind CSS', 'HTML5', 'CSS3', 'localStorage', 'Vercel'],
    liveUrl: 'https://time-manager-app-ten.vercel.app/',
    repoUrl: 'https://github.com/Naledi-starr/Time-Manager-App',
  },
 ];